<div style="position: fixed; top: 0px; width: 100%; text-align: center; z-index: 2000;" [hidden]="!loading">
  <span class="label label-important loading-counter">En cours
     <span class="loader__dot">.</span>
      <span class="loader__dot">.</span>
      <span class="loader__dot">.</span>
  </span>
</div>
